(() => {
  const MINIMUM_QUANTITY = 25;

  const isFrench = () => (document.documentElement.lang || '').toLowerCase().startsWith('fr');

  function normalizeQuantity(qty) {
    if (!qty) return;
    const value = Number(qty.value || 0);
    if (!value || value < MINIMUM_QUANTITY) {
      qty.value = String(MINIMUM_QUANTITY);
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyProductRules(info) {
    if (!info) return;
    const qty = info.querySelector('.quantity__input');
    const note = info.querySelector('[data-souvelle-moq]');
    const priceHost = info.querySelector('[id^="price-"]');
    if (!qty) return;

    qty.dataset.souvelleMin = String(MINIMUM_QUANTITY);
    qty.dataset.min = String(MINIMUM_QUANTITY);
    qty.min = String(MINIMUM_QUANTITY);

    // Do not force the value back to 25 while the customer is typing.
    // This allows direct entries such as 50, 75, 100, 250, etc.
    if (document.activeElement !== qty) {
      normalizeQuantity(qty);
    }

    if (note) {
      const title = note.querySelector('.souvelle-moq__title');
      const sub = note.querySelector('.souvelle-moq__sub');
      if (title && sub) {
        if (isFrench()) {
          if (title.textContent !== 'Commande minimum : 25 pièces') title.textContent = 'Commande minimum : 25 pièces';
          if (sub.textContent !== 'Créé à la commande, spécialement pour votre événement.') sub.textContent = 'Créé à la commande, spécialement pour votre événement.';
        } else {
          if (title.textContent !== 'Minimum order: 25 pieces') title.textContent = 'Minimum order: 25 pieces';
          if (sub.textContent !== 'Made to order, especially for your event.') sub.textContent = 'Made to order, especially for your event.';
        }
      }
    }

    if (priceHost) {
      let unit = priceHost.querySelector('.souvelle-unit-label');
      if (!unit) {
        unit = document.createElement('span');
        unit.className = 'souvelle-unit-label';
        priceHost.appendChild(unit);
      }
      const unitText = isFrench() ? '/ pièce' : '/ piece';
      if (unit.textContent !== unitText) unit.textContent = unitText;
    }
  }

  function applyAll() {
    document.querySelectorAll('product-info[data-product-id]').forEach(applyProductRules);
  }

  let frame;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(applyAll);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();

  document.addEventListener('change', (event) => {
    const info = event.target.closest && event.target.closest('product-info[data-product-id]');
    if (info) setTimeout(() => applyProductRules(info), 0);
  });

  document.addEventListener('blur', (event) => {
    if (!event.target.classList || !event.target.classList.contains('quantity__input')) return;
    normalizeQuantity(event.target);
  }, true);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
